import { render } from "./StoreProductCategoriesList.vue?vue&type=template&id=ada58cf6"
import script from "./StoreProductCategoriesList.vue?vue&type=script&lang=js"
export * from "./StoreProductCategoriesList.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__